import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";
import apiRequestType from "../../apiRequestType";

let cancelToken;
const getDefaultShotClassInformation = () => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.REPORT.ANALYTICAL_REPORT.GET_DEFAULT_SHOTCLASS_INFORMATION,
    cancelToken
  );
};

export default getDefaultShotClassInformation;
